export const mentorshipHero = {
  title: 'Mentorship Programs',
  subtitle: 'Connecting Pulau Pinang youth with experienced professionals who guide, inspire, and empower the next generation.',
  imageUrl: 'https://readdy.ai/api/search-image?query=Mentor%20and%20young%20student%20having%20meaningful%20discussion%20in%20modern%20community%20center%2C%20warm%20lighting%2C%20genuine%20connection%2C%20Malaysian%20participants%2C%20inspirational%20atmosphere&width=1600&height=800&seq=hero-mentorship&orientation=landscape',
};

export const mentorshipStats = [
  { value: '150+', label: 'Active Mentor-Mentee Pairs' },
  { value: '50+', label: 'Dedicated Mentors' },
  { value: '92%', label: 'Program Retention' },
  { value: '80%', label: 'Career Progression Rate' },
];

export const howItWorks = [
  {
    step: '01',
    title: 'Apply',
    description: 'Youth aged 16-30 can apply online or visit our center. We review applications to understand your goals and interests.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '02',
    title: 'Match',
    description: 'We carefully match you with a mentor whose experience and personality align with your aspirations and needs.',
    icon: 'ri-heart-line',
  },
  {
    step: '03',
    title: 'Connect',
    description: 'Meet your mentor for regular one-on-one sessions, group workshops, and networking events over a 6-month cycle.',
    icon: 'ri-shake-hands-line',
  },
  {
    step: '04',
    title: 'Grow',
    description: 'Set goals, track progress, and build the skills and confidence needed to succeed in your chosen path.',
    icon: 'ri-seedling-line',
  },
];

export const mentorProfiles = [
  {
    name: 'Dr. Faridah Hassan',
    role: 'Senior Mentor — Technology',
    bio: 'With over 15 years in the Malaysian tech industry, Dr. Faridah has guided more than 40 mentees into successful IT careers. She specializes in career coaching and technical skill development.',
    expertise: ['Software Engineering', 'Career Coaching', 'Startup Advisory'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20Malaysian%20woman%20in%20tech%2C%20confident%20smile%2C%20modern%20office%20setting%2C%20warm%20portrait%20photography%2C%20professional%20attire%2C%20natural%20lighting%2C%20clean%20background&width=400&height=400&seq=mentor-dr-faridah-hassan&orientation=squarish',
  },
  {
    name: 'Mr. Rajan A/L Muthu',
    role: 'Mentor — Business & Entrepreneurship',
    bio: 'Founder of three successful SMEs in Penang, Rajan brings real-world business experience to his mentorship. He has helped over 25 young entrepreneurs launch their first ventures.',
    expertise: ['Business Strategy', 'Entrepreneurship', 'Financial Literacy'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Malaysian%20Indian%20businessman%2C%20friendly%20professional%20portrait%2C%20modern%20office%20background%2C%20warm%20smile%2C%20professional%20attire%2C%20natural%20light%2C%20clean%20composition&width=400&height=400&seq=mentor-mr-rajan-a-l-muthu&orientation=squarish',
  },
  {
    name: 'Ms. Lee Mei Ling',
    role: 'Mentor — Education & Career Guidance',
    bio: 'A former secondary school teacher turned career counselor, Mei Ling has dedicated 10 years to helping youth discover their potential and navigate educational opportunities.',
    expertise: ['Career Counseling', 'Education Pathways', 'Personal Development'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Malaysian%20Chinese%20woman%20educator%20portrait%2C%20warm%20friendly%20expression%2C%20bookshelf%20background%2C%20professional%20casual%20attire%2C%20natural%20lighting%2C%20inspiring%20atmosphere&width=400&height=400&seq=mentor-ms-lee-mei-ling&orientation=squarish',
  },
  {
    name: 'Encik Zulkifli Ismail',
    role: 'Mentor — Digital Skills & Media',
    bio: 'A digital content creator and educator with a passion for youth empowerment, Zulkifli teaches digital media production and helps mentees build their online presence.',
    expertise: ['Digital Media', 'Content Creation', 'Public Speaking'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Malaysian%20Malay%20man%20in%20creative%20workspace%2C%20friendly%20portrait%2C%20camera%20equipment%20in%20background%2C%20modern%20creative%20setting%2C%20warm%20lighting%2C%20professional%20casual%20style&width=400&height=400&seq=mentor-encik-zulkifli-ismail&orientation=squarish',
  },
];

export const mentorshipTestimonials = [
  {
    name: 'Aisyah Binti Rahman',
    role: 'Mentee, 2025 Cycle',
    text: 'My mentor helped me see possibilities I never knew existed. I went from feeling lost after secondary school to confidently pursuing a diploma in business management.',
  },
  {
    name: 'Kumar A/L Selvan',
    role: 'Mentee, 2024 Cycle',
    text: 'The mentorship program didn\'t just help my career — it helped me grow as a person. My mentor taught me discipline, communication, and how to set real goals.',
  },
  {
    name: 'Tan Wei Ling',
    role: 'Mentee, 2025 Cycle',
    text: 'I was matched with a mentor who understood exactly what I was going through. Six months later, I landed my first job in digital marketing. This program changes lives.',
  },
];

export const mentorshipFAQ = [
  {
    question: 'How long does the mentorship program last?',
    answer: 'Each mentorship cycle runs for 6 months, with weekly one-on-one sessions (either in-person or online) and monthly group workshops. Participants can re-enroll for additional cycles.',
  },
  {
    question: 'Is there a cost to join?',
    answer: 'No, our mentorship program is completely free for all eligible youth. It is funded through donations, grants, and volunteer commitment from our mentors.',
  },
  {
    question: 'How are mentors and mentees matched?',
    answer: 'We use a careful matching process based on career interests, personality compatibility, goals, and availability to ensure productive and meaningful mentorship relationships.',
  },
  {
    question: 'Can I become a mentor?',
    answer: 'Absolutely! We welcome professionals from all backgrounds. Visit our center or email us to learn about becoming a volunteer mentor.',
  },
];